import request from '../utils/http'
// 日志列表
export function index (query) {
  return request({
    url: '/importLog/list',
    method: 'GET',
    params: query
  })
}
// 导出日志
export function errorDataExport (query) {
  return request({
    url: '/importLog/errorDataExport',
    method: 'POST',
    responseType: 'blob',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/journal.js